import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-access-request" },
    [
      !_vm.tplToWork ? _c("p", [_vm._v("Template not found!")]) : _vm._e(),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": true,
          "is-full-page": true,
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm.tplToWork && _vm.defaultFields
        ? _c(
            "b-form",
            { staticClass: "form", on: { submit: _vm.onSubmit } },
            [
              _c(
                VRow,
                [
                  _vm.tplToWork.item.created
                    ? _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c("h6", [_vm._v("Initial date for the request")]),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: _vm.$t("my_tasks.modals.request_since"),
                                "label-cols": "3",
                              },
                            },
                            [
                              _c(VTextField, {
                                attrs: {
                                  filled: "",
                                  dense: "",
                                  size: "sm",
                                  type: "date",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.tplToWork.item.created,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.tplToWork.item, "created", $$v)
                                  },
                                  expression: "tplToWork.item.created",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "4" } },
                    [
                      _c("h6", [_vm._v("Fecha límite para la solicitud")]),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "sm",
                            label: "Request until",
                            "label-cols": "3",
                          },
                        },
                        [
                          _vm.tplToWork.tipo == "vista"
                            ? [
                                _c("b-form-input", {
                                  attrs: {
                                    size: "sm",
                                    type: "date",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.tplToWork.item.endDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tplToWork.item,
                                        "endDate",
                                        $$v
                                      )
                                    },
                                    expression: "tplToWork.item.endDate",
                                  },
                                }),
                              ]
                            : [
                                _c("b-form-input", {
                                  attrs: {
                                    size: "sm",
                                    type: "date",
                                    required: "",
                                    placeholder: "DD/MM/YYYY",
                                  },
                                  model: {
                                    value: _vm.toSave.endDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.toSave, "endDate", $$v)
                                    },
                                    expression: "toSave.endDate",
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.tplToWork.tipo != "vista"
                    ? _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "1", "offset-md": "2" } },
                        [
                          _c(
                            "b-input-group",
                            {
                              staticClass: "input-mini",
                              attrs: { size: "sm" },
                            },
                            [
                              _c(
                                "b-button-group",
                                { attrs: { size: "sm" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-primary",
                                        size: "sm",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.$refs.fileInput2.$el
                                            .querySelector("input[type=file]")
                                            .click()
                                        },
                                      },
                                    },
                                    [_vm._v("Attach"), _c("b-icon-paperclip")],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("b-form-file", {
                                ref: "fileInput2",
                                staticStyle: { display: "none" },
                                attrs: {
                                  accept:
                                    _vm.ACCES_REQUEST_FILE_FORMAT.join(","),
                                },
                                on: { change: _vm.onFileChange },
                                model: {
                                  value: _vm.inputUploadFile,
                                  callback: function ($$v) {
                                    _vm.inputUploadFile = $$v
                                  },
                                  expression: "inputUploadFile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tplToWork.tipo != "vista"
                    ? _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "5" } },
                        [
                          _c(
                            "b-table-simple",
                            { attrs: { small: true, hover: true } },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c(
                                    "b-tr",
                                    [_c("b-th", [_vm._v("File")]), _c("b-th")],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-tbody",
                                _vm._l(_vm.files, function (file, index) {
                                  return _c(
                                    "b-tr",
                                    { key: index },
                                    [
                                      _c("b-td", [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openImage(
                                                  file.fileLink
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(file.fileName))]
                                        ),
                                      ]),
                                      _c("b-td", [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            attrs: { title: "Delete" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteFile(file)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass: "material-icons",
                                                staticStyle: {
                                                  color: "blue",
                                                  "font-size": "medium",
                                                },
                                              },
                                              [_vm._v("delete")]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                show: _vm.dismissCountDown,
                                dismissible: "",
                                variant: "danger",
                              },
                              on: {
                                dismissed: function ($event) {
                                  _vm.dismissCountDown = 0
                                },
                                "dismiss-count-down": _vm.countDownChanged,
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "File format is not supported, compress it into .zip instead"
                                ),
                              ]),
                              _c("b-progress", {
                                attrs: {
                                  variant: "danger",
                                  max: _vm.dismissSecs,
                                  value: _vm.dismissCountDown,
                                  height: "4px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tplToWork.tipo != "vista",
                      expression: "tplToWork.tipo !='vista'",
                    },
                  ],
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "6" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          staticClass: "input-mini",
                          attrs: { size: "sm", prepend: "External User" },
                        },
                        [
                          _c("b-form-checkbox", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.right",
                                value: "Set external user",
                                expression: "'Set external user'",
                                modifiers: { hover: true, right: true },
                              },
                            ],
                            attrs: {
                              id: "checkbox-service-account",
                              name: "checkbox-service-account",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChangeExternalUser()
                              },
                            },
                            model: {
                              value: _vm.isExternalUser,
                              callback: function ($$v) {
                                _vm.isExternalUser = $$v
                              },
                              expression: "isExternalUser",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExternalUser,
                      expression: "isExternalUser",
                    },
                  ],
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "6" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          staticClass: "input-mini",
                          attrs: { size: "sm", prepend: "Type" },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              options: _vm.externalUserOptions,
                              required: _vm.isExternalUser,
                              disabled: _vm.tplToWork.tipo === "vista",
                            },
                            model: {
                              value: _vm.externalUserType,
                              callback: function ($$v) {
                                _vm.externalUserType = $$v
                              },
                              expression: "externalUserType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExternalUser && _vm.externalUserType != 3,
                      expression: "isExternalUser && externalUserType != 3",
                    },
                  ],
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "6" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          staticClass: "input-mini",
                          attrs: { size: "sm", prepend: "Client email" },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              required:
                                _vm.isExternalUser && _vm.externalUserType != 3,
                              disabled: _vm.tplToWork.tipo === "vista",
                            },
                            model: {
                              value: _vm.benefited,
                              callback: function ($$v) {
                                _vm.benefited = $$v
                              },
                              expression: "benefited",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExternalUser,
                      expression: "isExternalUser",
                    },
                  ],
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "6" } },
                    [
                      _c(
                        "b-input-group",
                        {
                          staticClass: "input-mini",
                          attrs: { size: "sm", prepend: "Use case" },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              placeholder: "why do you need this data?",
                              required: _vm.isExternalUser,
                              disabled: _vm.tplToWork.tipo === "vista",
                            },
                            model: {
                              value: _vm.businessCase,
                              callback: function ($$v) {
                                _vm.businessCase = $$v
                              },
                              expression: "businessCase",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "6" } },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            show: _vm.deployMessage,
                            variant: "danger",
                            dismissible: "",
                          },
                        },
                        [_vm._v(_vm._s(_vm.message))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    [
                      _c("label", [
                        _vm._v(
                          "Table: " +
                            _vm._s(
                              _vm._f("joinTableReference")(
                                _vm.tplToWork.item.tableReference
                              )
                            )
                        ),
                      ]),
                      _vm.tplToWork.tipo == "vista"
                        ? [
                            _c("list-table-metadata-cols", {
                              attrs: {
                                columnFields: _vm.columnFields,
                                defaultFields: _vm.defaultFields,
                                isChangeRequest:
                                  _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                                showTitle: false,
                                isRequestView: false,
                                isOwnerApproval: false,
                              },
                            }),
                          ]
                        : [
                            _c("list-table-metadata-cols", {
                              attrs: {
                                columnFields: _vm.columnFields,
                                defaultFields: _vm.defaultFields,
                                isChangeRequest:
                                  _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                                showTitle: false,
                                isRequestView: true,
                                isOwnerApproval: false,
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.tplToWork.tipo == "vista"
                ? _c(
                    VRow,
                    { staticClass: "mb-0" },
                    [
                      _c(
                        VCol,
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold pl-0" },
                            [_vm._v("Request reason")]
                          ),
                          _c(VTextarea, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rows: "2",
                              disabled: "",
                            },
                            model: {
                              value: _vm.tplToWork.item.commentary,
                              callback: function ($$v) {
                                _vm.$set(_vm.tplToWork.item, "commentary", $$v)
                              },
                              expression: "tplToWork.item.commentary",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    [
                      _c(
                        VSubheader,
                        { staticClass: "font-weight-bold pl-0" },
                        [_vm._v(_vm._s(_vm.$t("my_tasks.response_reason")))]
                      ),
                      _vm.tplToWork.tipo == "vista"
                        ? _c(VTextarea, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rows: "2",
                              disabled: "",
                            },
                            model: {
                              value: _vm.tplToWork.item.response,
                              callback: function ($$v) {
                                _vm.$set(_vm.tplToWork.item, "response", $$v)
                              },
                              expression: "tplToWork.item.response",
                            },
                          })
                        : _c(VTextarea, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rows: "2",
                              placeholder: "Message...",
                            },
                            model: {
                              value: _vm.toSave.commentary,
                              callback: function ($$v) {
                                _vm.$set(_vm.toSave, "commentary", $$v)
                              },
                              expression: "toSave.commentary",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("hr"),
              _vm.tplToWork.tipo != "vista"
                ? _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-button",
                        { attrs: { size: "sm" }, on: { click: _vm.onCancel } },
                        [
                          _c("i", { staticClass: "material-icons md-16" }, [
                            _vm._v("cancel"),
                          ]),
                          _vm._v("Cancel"),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "active ml-2",
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            size: "sm",
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons md-16" }, [
                            _vm._v("send"),
                          ]),
                          _vm._v("Request"),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c("b", [_vm._v("Apparently the table has no associated metadata")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }